const messages = {
  "es": {
    "TU NEGOCIO, CONECTADO": "TU NEGOCIO, CONECTADO",
    "Más claridad. Más posibilidades.": "Más claridad. Más posibilidades.",
    "Organiza tu negocio en un solo lugar, con BRIEFY a tu lado.": "Organiza tu negocio en un solo lugar, con BRIEFY a tu lado.",
    "Ventas": "Ventas",
    "Finanzas": "Finanzas",
    "Clientes": "Clientes",
    "Documentos": "Documentos",
    "BUSINESS MANAGEMENT SUITE": "BUSINESS MANAGEMENT SUITE",
    "BIENVENIDO A TU ESPACIO": "BIENVENIDO A TU ESPACIO",
    "Verifica tu acceso": "Verifica tu acceso",
    "Qué bueno verte.": "Qué bueno verte.",
    "Comienza con BRIEFCASE": "Comienza con BRIEFCASE",
    "Usa tu aplicación autenticadora o un código de respaldo.": "Usa tu aplicación autenticadora o un código de respaldo.",
    "Ingresa para continuar con tu negocio.": "Ingresa para continuar con tu negocio.",
    "Crea tu cuenta y organiza lo que viene.": "Crea tu cuenta y organiza lo que viene.",
    "Código de verificación": "Código de verificación",
    "Verificando…": "Verificando…",
    "Verificar": "Verificar",
    "Cancelar y volver": "Cancelar y volver",
    "Ingresar": "Ingresar",
    "Crear cuenta": "Crear cuenta",
    "¿Olvidaste tu contraseña?": "¿Olvidaste tu contraseña?",
    "Continuar con Google": "Continuar con Google",
    "¿No tienes cuenta? Regístrate": "¿No tienes cuenta? Regístrate",
    "¿Ya tienes cuenta? Ingresa": "¿Ya tienes cuenta? Ingresa",
    "Gestión empresarial inteligente": "Gestión empresarial inteligente",
    "Mi empresa": "Mi empresa",
    "o": "o",
    "Error al iniciar sesión. Verifica tus datos.": "Error al iniciar sesión. Verifica tus datos.",
    "No se pudo completar el acceso. Revisa los campos e inténtalo de nuevo.": "No se pudo completar el acceso. Revisa los campos e inténtalo de nuevo.",
    "Error de conexión. Por favor verifica tu internet e intenta de nuevo.": "Error de conexión. Por favor verifica tu internet e intenta de nuevo.",
    "Tiempo de espera agotado. Intenta de nuevo.": "Tiempo de espera agotado. Intenta de nuevo.",
    "Código 2FA inválido": "Código 2FA inválido",
    "Suite de gestión empresarial": "Suite de gestión empresarial",
    "Contraseña": "Contraseña",
    "Nombre del negocio": "Nombre del negocio",
    "Correo electrónico": "Correo electrónico"
  },
  "en": {
    "TU NEGOCIO, CONECTADO": "YOUR BUSINESS, CONNECTED",
    "Más claridad. Más posibilidades.": "More clarity. More possibilities.",
    "Organiza tu negocio en un solo lugar, con BRIEFY a tu lado.": "Manage your business in one place, with BRIEFY by your side.",
    "Ventas": "Sales",
    "Finanzas": "Finances",
    "Clientes": "Customers",
    "Documentos": "Documents",
    "BUSINESS MANAGEMENT SUITE": "BUSINESS MANAGEMENT SUITE",
    "BIENVENIDO A TU ESPACIO": "WELCOME TO YOUR WORKSPACE",
    "Verifica tu acceso": "Verify your access",
    "Qué bueno verte.": "Good to see you.",
    "Comienza con BRIEFCASE": "Get started with BRIEFCASE",
    "Usa tu aplicación autenticadora o un código de respaldo.": "Use your authenticator app or a backup code.",
    "Ingresa para continuar con tu negocio.": "Sign in to continue managing your business.",
    "Crea tu cuenta y organiza lo que viene.": "Create your account and plan what comes next.",
    "Código de verificación": "Verification code",
    "Verificando…": "Verifying…",
    "Verificar": "Verify",
    "Cancelar y volver": "Cancel and go back",
    "Ingresar": "Sign in",
    "Crear cuenta": "Create account",
    "¿Olvidaste tu contraseña?": "Forgot your password?",
    "Continuar con Google": "Continue with Google",
    "¿No tienes cuenta? Regístrate": "No account yet? Sign up",
    "¿Ya tienes cuenta? Ingresa": "Already have an account? Sign in",
    "Gestión empresarial inteligente": "Intelligent business management",
    "Mi empresa": "My business",
    "o": "or",
    "Error al iniciar sesión. Verifica tus datos.": "Sign-in failed. Check your details.",
    "No se pudo completar el acceso. Revisa los campos e inténtalo de nuevo.": "Unable to sign in. Check the fields and try again.",
    "Error de conexión. Por favor verifica tu internet e intenta de nuevo.": "Connection error. Check your internet and try again.",
    "Tiempo de espera agotado. Intenta de nuevo.": "The request timed out. Try again.",
    "Código 2FA inválido": "Invalid 2FA code",
    "Suite de gestión empresarial": "Business management suite",
    "Contraseña": "Password",
    "Nombre del negocio": "Business name",
    "Correo electrónico": "Email address"
  },
  "pt": {
    "TU NEGOCIO, CONECTADO": "SEU NEGÓCIO, CONECTADO",
    "Más claridad. Más posibilidades.": "Mais clareza. Mais possibilidades.",
    "Organiza tu negocio en un solo lugar, con BRIEFY a tu lado.": "Organize seu negócio em um só lugar, com BRIEFY ao seu lado.",
    "Ventas": "Vendas",
    "Finanzas": "Finanças",
    "Clientes": "Clientes",
    "Documentos": "Documentos",
    "BUSINESS MANAGEMENT SUITE": "GESTÃO EMPRESARIAL",
    "BIENVENIDO A TU ESPACIO": "BEM-VINDO AO SEU ESPAÇO",
    "Verifica tu acceso": "Verifique seu acesso",
    "Qué bueno verte.": "Que bom ver você.",
    "Comienza con BRIEFCASE": "Comece com BRIEFCASE",
    "Usa tu aplicación autenticadora o un código de respaldo.": "Use seu aplicativo autenticador ou um código de recuperação.",
    "Ingresa para continuar con tu negocio.": "Entre para continuar gerenciando seu negócio.",
    "Crea tu cuenta y organiza lo que viene.": "Crie sua conta e organize seus próximos passos.",
    "Código de verificación": "Código de verificação",
    "Verificando…": "Verificando…",
    "Verificar": "Verificar",
    "Cancelar y volver": "Cancelar e voltar",
    "Ingresar": "Entrar",
    "Crear cuenta": "Criar conta",
    "¿Olvidaste tu contraseña?": "Esqueceu sua senha?",
    "Continuar con Google": "Continuar com Google",
    "¿No tienes cuenta? Regístrate": "Não tem conta? Cadastre-se",
    "¿Ya tienes cuenta? Ingresa": "Já tem conta? Entre",
    "Gestión empresarial inteligente": "Gestão empresarial inteligente",
    "Mi empresa": "Minha empresa",
    "o": "ou",
    "Error al iniciar sesión. Verifica tus datos.": "Falha ao entrar. Verifique seus dados.",
    "No se pudo completar el acceso. Revisa los campos e inténtalo de nuevo.": "Não foi possível entrar. Revise os campos e tente novamente.",
    "Error de conexión. Por favor verifica tu internet e intenta de nuevo.": "Erro de conexão. Verifique sua internet e tente novamente.",
    "Tiempo de espera agotado. Intenta de nuevo.": "Tempo de espera esgotado. Tente novamente.",
    "Código 2FA inválido": "Código 2FA inválido",
    "Suite de gestión empresarial": "Gestão empresarial",
    "Contraseña": "Senha",
    "Nombre del negocio": "Nome do negócio",
    "Correo electrónico": "E-mail"
  },
  "fr": {
    "TU NEGOCIO, CONECTADO": "VOTRE ENTREPRISE, CONNECTÉE",
    "Más claridad. Más posibilidades.": "Plus de clarté. Plus de possibilités.",
    "Organiza tu negocio en un solo lugar, con BRIEFY a tu lado.": "Gérez votre entreprise au même endroit, avec BRIEFY à vos côtés.",
    "Ventas": "Ventes",
    "Finanzas": "Finances",
    "Clientes": "Clients",
    "Documentos": "Documents",
    "BUSINESS MANAGEMENT SUITE": "GESTION D’ENTREPRISE",
    "BIENVENIDO A TU ESPACIO": "BIENVENUE DANS VOTRE ESPACE",
    "Verifica tu acceso": "Vérifiez votre accès",
    "Qué bueno verte.": "Heureux de vous revoir.",
    "Comienza con BRIEFCASE": "Commencez avec BRIEFCASE",
    "Usa tu aplicación autenticadora o un código de respaldo.": "Utilisez votre application d’authentification ou un code de secours.",
    "Ingresa para continuar con tu negocio.": "Connectez-vous pour continuer à gérer votre entreprise.",
    "Crea tu cuenta y organiza lo que viene.": "Créez votre compte et préparez la suite.",
    "Código de verificación": "Code de vérification",
    "Verificando…": "Vérification…",
    "Verificar": "Vérifier",
    "Cancelar y volver": "Annuler et revenir",
    "Ingresar": "Se connecter",
    "Crear cuenta": "Créer un compte",
    "¿Olvidaste tu contraseña?": "Mot de passe oublié ?",
    "Continuar con Google": "Continuer avec Google",
    "¿No tienes cuenta? Regístrate": "Pas encore de compte ? Inscrivez-vous",
    "¿Ya tienes cuenta? Ingresa": "Déjà un compte ? Connectez-vous",
    "Gestión empresarial inteligente": "Gestion d’entreprise intelligente",
    "Mi empresa": "Mon entreprise",
    "o": "ou",
    "Error al iniciar sesión. Verifica tus datos.": "Échec de connexion. Vérifiez vos informations.",
    "No se pudo completar el acceso. Revisa los campos e inténtalo de nuevo.": "Connexion impossible. Vérifiez les champs et réessayez.",
    "Error de conexión. Por favor verifica tu internet e intenta de nuevo.": "Erreur de connexion. Vérifiez votre connexion Internet et réessayez.",
    "Tiempo de espera agotado. Intenta de nuevo.": "Le délai a expiré. Réessayez.",
    "Código 2FA inválido": "Code 2FA invalide",
    "Suite de gestión empresarial": "Gestion d’entreprise",
    "Contraseña": "Mot de passe",
    "Nombre del negocio": "Nom de l’entreprise",
    "Correo electrónico": "Adresse e-mail"
  }
};
export const authText = (language, text) => messages[language]?.[text] || messages.es[text] || text;
